module.exports = __webpack_public_path__ + "static/media/agent12.fb6007e9.png";